import * as React from 'react';
import cx from 'classnames';
import styles from './FormattedMessage.css';
export const fontWeightMapping = {
    normal: 400,
    medium: 500,
    bold: 700
};
export default function RichTextView(props) {
    const { value, textClass } = props;
    if (!value) {
        return null;
    }
    const { text, style, title, textColor, textSize } = value;
    let cssStyle = {};
    // textColor and textSize are outside of style object.
    // Adding them to style object, if they're present.
    if (textColor) {
        cssStyle.color = textColor;
    }
    // textSize is number, converting it to px.
    if (textSize) {
        cssStyle.fontSize = `${textSize}px`;
    }
    if (style) {
        const { fontWeight, fontSize, lineHeight } = style;
        cssStyle = Object.assign(Object.assign({}, cssStyle), style);
        // fontSize and lineHeight are numbers, converting them to px.
        if (fontSize) {
            cssStyle.fontSize = `${fontSize}px`;
        }
        if (lineHeight) {
            cssStyle.lineHeight = `${lineHeight}px`;
        }
        if (fontWeight) {
            cssStyle.fontWeight = fontWeightMapping[fontWeight];
        }
    }
    // giving preference to text over title
    return (<div className={cx(styles['text-snippet'], textClass)} style={cssStyle}>
			{text || title}
		</div>);
}
